import Avatar from 'react-avatar';
import { RiArrowRightSLine } from 'react-icons/ri';

import { company, email, location, phone, web, whatsapp, nfclogoBlack, whiteLogo, UndpRwandaLogo } from '../assets';
import { getFieldTypeLabel } from '../constants';
import BottomSheet from '../components/BottomSheet';
import { truncateString } from '../utils';
import UNDPModal from './modals/UNDPModal';

// api
const API_URL = process.env.REACT_APP_BASE_API_URL;
const UndpRwanda = ({ profile, toggle, modal, setModal, id, handleOrderYours, isLoading }) => {
  return (
    <>
      {profile?.data?.tag_info && (
        <div className='mx-auto max-w-[560px] text-center mt-2'>
          <div className=' relative '>
            <div className='relative'>
              <div className='undp-nfc-logo'>
                <img src={nfclogoBlack} alt='NFC Logo' />
              </div>
              <div className='w-full'>
                <img src={UndpRwandaLogo} alt='Top Logo' className='w-[200px] mx-auto py-4' />
                <div className='bg-[#1469b3] h-[70px]'></div>
              </div>
              <div className='undp-biz-logo'>
                <img src={whiteLogo} alt='Visa Logo' />
              </div>
            </div>
            <div className='top-[80px] absolute inset-0 flex flex-col items-center justify-center'>
              <>
                {!profile?.data?.tag_info?.avatar ? (
                  <Avatar
                    style={{
                      border: '5px solid #fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '120px',
                      height: '120px',
                      fontStyle: 'Lemonmilk-Regular',
                    }}
                    name={`${profile?.data?.tag_info?.fname} ${profile?.data?.tag_info?.lname}`}
                    round
                    color='#1469b3'
                    fgColor='#fff'
                    size={110}
                  />
                ) : (
                  <div className='bg-white rounded-full  border-[4px] border-[#089edb]'>
                    <img
                      src={profile?.data?.tag_info?.avatar}
                      alt='profile'
                      className='w-[110px] h-[110px] object-cover object-top rounded-full z-1 p-1'
                    />
                  </div>
                )}
              </>
            </div>
            <div className=' text-center pt-[60px]'>
              <p className='text-[#000] text-[20px] font-bold font-[Lemonmilk-Regular] '>
                {profile?.data?.tag_info?.title} {profile?.data?.tag_info?.fname} {profile?.data?.tag_info?.lname}
              </p>
              <p className='text-[12px] text-[#000] font-[Lemonmilk-Regular] leading-[1.5] mb-4'>
                {profile?.data?.tag_info?.position}
              </p>
            </div>
          </div>

          <div className='mx-4 actionsBtn'>
            <div className='flex items-center justify-between mb-8'>
              <button
                className='bg flex items-center gap-1 py-[10px] px-6 border-[1px] border-[#1469b3] bg-opacity-95 text-[#1469b3] font-bold text-[13px] w-1/2 justify-center mr-2 font-[Lemonmilk-Regular]'
                onClick={toggle}
              >
                <svg
                  id='arrow-up-down'
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 16.326 13.814'
                >
                  <path
                    id='Path_17'
                    data-name='Path 17'
                    d='M24.272,7.875a.609.609,0,0,1,.647.561v10.1a.654.654,0,0,1-1.295,0V8.436A.609.609,0,0,1,24.272,7.875Z'
                    transform='translate(-12.367 -7.284)'
                    fill='#1469b3'
                    fillRule='evenodd'
                  />
                  <path
                    id='Path_18'
                    data-name='Path 18'
                    d='M14.859,5.808a.628.628,0,0,1,.889,0l3.767,3.767a.629.629,0,0,1-.889.889L15.3,7.14,11.98,10.463a.629.629,0,1,1-.889-.889l3.767-3.767ZM3.558,14.6a.628.628,0,0,1,.889,0l3.322,3.323L11.092,14.6a.629.629,0,0,1,.889.889L8.214,19.253a.628.628,0,0,1-.889,0L3.558,15.486a.628.628,0,0,1,0-.889Z'
                    transform='translate(-3.373 -5.623)'
                    fill='#1469b3'
                    fillRule='evenodd'
                  />
                  <path
                    id='Path_19'
                    data-name='Path 19'
                    d='M10.8,5.625a.624.624,0,0,1,.672.561v10.1a.683.683,0,0,1-1.344,0V6.186A.624.624,0,0,1,10.8,5.625Z'
                    transform='translate(-6.266 -4.159)'
                    fill='#1469b3'
                    fillRule='evenodd'
                  />
                </svg>
                &nbsp;Exchange
              </button>

              <a
                href={`${API_URL}api/v1/cards/vcard/${id}`}
                className='flex items-center py-[12px] bg-[#1469b3] text-[#FFFFFF] font-bold text-[13px] w-1/2 justify-center ml-2 font-[Lemonmilk-Regular]'
              >
                <svg
                  id='user-add'
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 17.207 17.375'
                >
                  <path
                    id='Path_6'
                    data-name='Path 6'
                    d='M9.5,11.5A3.5,3.5,0,1,0,6,8,3.5,3.5,0,0,0,9.5,11.5Zm0-1.751A1.751,1.751,0,1,0,7.751,8,1.751,1.751,0,0,0,9.5,9.753Z'
                    transform='translate(-3.863 -4.5)'
                    fill='#fff'
                    fillRule='evenodd'
                  />
                  <path
                    id='Path_7'
                    data-name='Path 7'
                    d='M11.458,19.88a.94.94,0,0,1,.94.94v5.639h1.88V20.819A2.819,2.819,0,0,0,11.458,18H5.819A2.819,2.819,0,0,0,3,20.819v5.639H4.88V20.819a.94.94,0,0,1,.94-.94Z'
                    transform='translate(-3 -9.083)'
                    fill='#fff'
                  />
                  <path
                    id='Path_8'
                    data-name='Path 8'
                    d='M25.977,10.5h1.977v1.977H29.93v1.977H27.953V16.43H25.977V14.453H24V12.477h1.977Z'
                    transform='translate(-12.723 -6.998)'
                    fill='#fff'
                  />
                </svg>
                &nbsp;&nbsp;Save Contact
              </a>
            </div>
          </div>
          <div className='user-infoSection'>
            <div className='mt-4'>
              <h5 className='font-bold text-[18px] text-[#143047] font-[Lemonmilk-Regular]'>Personal Info</h5>
              <div className='mt-3 space-y-1'></div>
            </div>

            <div className='space-y-6'>
              {/* Company */}
              <div className='flex items-center justify-between'>
                <div className='flex items-center space-x-4'>
                  <div className='bg-[#009edc50]  p-[12px] rounded-lg info-icon'>
                    <img src={company} alt='company' />
                  </div>
                  <div>
                    <p className='info-title font-[Lemonmilk-Regular]'>Company</p>
                    <p className='info-content font-[Lemonmilk-Regular]'>{profile?.data?.tag_info.company}</p>
                  </div>
                </div>
                <div>
                  <RiArrowRightSLine size={25} className='text-[#009edc50]' />
                </div>
              </div>

              {/* Personal Phone Number */}
              {profile?.data?.tag_info?.phones.map(item =>
                item?.value ? (
                  <div key={item?.value} className='flex items-center justify-between'>
                    <a href={`tel:${item?.value || ''}`} className='flex items-center space-x-4'>
                      <div className='bg-[#009edc50]  p-[12px] rounded-lg info-icon'>
                        <img src={phone} alt='phone' />
                      </div>
                      <div>
                        <p className='info-title font-[Lemonmilk-Regular]'>
                          Phone ({getFieldTypeLabel(item.type) || ''})
                        </p>
                        <p className='info-content font-[Lemonmilk-Regular]'>{item?.value || ''}</p>
                      </div>
                    </a>
                    {item?.value !== '' && item?.value === '+41 22 9990 099' ? null : (
                      <a
                        href={`https://wa.me/${String(item?.value).replace(/[^0-9]/g, '') || ''}`}
                        className='info-icon'
                      >
                        <img src={whatsapp} alt='whatsapp' />
                      </a>
                    )}
                  </div>
                ) : null
              )}
              {/* Email Address */}
              {profile?.data?.tag_info?.emails.map(item =>
                item?.value ? (
                  <div key={item?.value} className='flex items-center justify-between'>
                    <a href={`mailto:${item?.value || ''}`} className='flex items-center space-x-4'>
                      <div className='bg-[#009edc50]  p-[12px] rounded-lg info-icon'>
                        <img src={email} alt='email' />
                      </div>
                      <div>
                        <p className='info-title font-[Lemonmilk-Regular]'>
                          Email ({getFieldTypeLabel(item?.type) || ''})
                        </p>
                        <p className='info-content font-[Lemonmilk-Regular]'>{item?.value || ''}</p>
                      </div>
                    </a>
                    <a href={`mailto:${item?.value || ''}`}>
                      <RiArrowRightSLine size={25} className='text-[#009edc50]' />
                    </a>
                  </div>
                ) : null
              )}

              {/* websites */}
              {profile?.data?.tag_info?.websites?.map(item =>
                item?.value ? (
                  <div key={item?.value} className='flex items-center justify-between'>
                    <a href={item?.value || '#'} className='flex items-center space-x-4'>
                      <div className='bg-[#009edc50]  p-[12px] rounded-lg info-icon'>
                        <img src={web} alt='web' />
                      </div>
                      <div>
                        <p className='info-title font-[Lemonmilk-Regular]'>
                          Website ({getFieldTypeLabel(item.type) || ''})
                        </p>
                        <p className='info-content font-[Lemonmilk-Regular]'>{truncateString(item?.value, 35) || ''}</p>
                      </div>
                    </a>
                    <a href={item?.value || '#'}>
                      <RiArrowRightSLine size={25} className='text-[#009edc50]' />
                    </a>
                  </div>
                ) : null
              )}

              {/* Addresses */}
              {profile?.data?.tag_info?.addresses?.map(item =>
                item?.value ? (
                  <div key={item?.value} className='flex items-center justify-between'>
                    <a href={item?.value || '#'} className='flex items-center space-x-4'>
                      <div className='bg-[#009edc50]  p-[12px] rounded-lg w-[50px] h-[50px] flex items-center justify-center'>
                        <img src={location} alt='web' />
                      </div>
                      <div>
                        <p className='info-title font-[Lemonmilk-Regular]'>
                          Addresses ({getFieldTypeLabel(item.type) || ''})
                        </p>
                        <p className='info-content font-[Lemonmilk-Regular]'>{truncateString(item?.value, 35) || ''}</p>
                      </div>
                    </a>
                    <a href={'/'} className='info-icon'>
                      <img src={location} alt='whatsapp' />
                    </a>
                  </div>
                ) : null
              )}
            </div>
          </div>

          <div className='my-4 bg-[#F5FAFF] p-4'>
            <button
              className='w-full py-[8px] border-[#1469b3] text-[#1469b3] border-[2px] rounded-lg text-[15px] font-[Lemonmilk-Regular]'
              onClick={handleOrderYours}
            >
              Order Yours Now
            </button>
          </div>
        </div>
      )}
      {profile?.data?.tag_info && (
        <BottomSheet isOpen={modal} onChange={toggle} tagInfo={profile?.data?.tag_info && profile?.data?.tag_info}>
          <UNDPModal info={profile?.data?.tag_info} setModal={setModal} tagId={profile?.data?.id} />
        </BottomSheet>
      )}

      {!profile?.data?.tag_info && !isLoading && (
        <div className='mx-auto max-w-[560px] text-center pt-[45vh]'>
          <h3 className='text-primary text-[20px] font-bold font-[Lemonmilk-Regular]'>We couldn't find that profile</h3>
          <small className='pt-3 text-[12px] text-red-900 font-[Lemonmilk-Regular]'>
            This might be due to poor network or that profile doesn't exist
          </small>
        </div>
      )}
    </>
  );
};

export default UndpRwanda;
